import React from "react";
import {Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {formatFullDateTime} from "./applicationUtils";

// Geçen süre metninin üzerine gelindiğinde başvuru ve (varsa) sonuçlanma tarihi gerçek saatiyle gösterilir
export const ApplicationElapsedTime = ({application}) => {
    const {t} = useTranslation(["applications"]);

    const renderEntry = (key, date) => (
        <div key={key}>
            <div>{t(`elapsed.${key}`, {ns: "applications"})}</div>
            <div>{formatFullDateTime(date)}</div>
        </div>
    );

    const title = (
        <>
            {renderEntry("createdAt", application.createdAt)}
            {application.resolvedAt && (
                <div style={{marginTop: 8}}>{renderEntry("resolvedAt", application.resolvedAt)}</div>
            )}
        </>
    );

    return (
        <Tooltip title={title}>
            <span>{application.elapsed}</span>
        </Tooltip>
    );
};
